class HHHeaderSubmenu extends HTMLElement {
  static properties = {
    _open: {
      state: false
    }
  }

  constructor() {
    super();
    this.anchorEl = this.querySelector('.js-submenu-anchor');
    this.menuEl = this.querySelector(this.dataset.target);
    this.mobileBack = this.querySelector('.js-submenu-back');
    this.mobileCloseAll = this.querySelector('.js-submenu-close');
    this.isMobile = this.dataset.mobile

    this.toggle = this.toggle.bind(this);
    this.handleTransitionEnd = this.handleTransitionEnd.bind(this)

    this.anchorEl.addEventListener('click', this.toggle);
    this.anchorEl.addEventListener('keydown', (e) => {
      if (e.code.toUpperCase() === "ENTER") {
        e.preventDefault();
        this.anchorEl.click()
      };
    });
    this.mobileBack?.addEventListener('click', this.mobileSubmenuClose.bind(this));
    this.mobileCloseAll?.addEventListener('click', this.mobileSubmenuCloseAll.bind(this));

    this.addEventListener('focusout', (e) => {
      if (this._open && !e.currentTarget.contains(e.relatedTarget) && !this.isMobile) {
        this.close()
      } else if (this.isMobile && !this.contains(e.target)) {
        this.close()
      }
    })

    document.addEventListener('keydown', (e) => {
      if (this._open && e.code.toUpperCase() == 'ESCAPE') {
        this.close()
      }
    })
  }

  toggle(e) {
    e.preventDefault();
    this._open ? this.close() : this.open();
  }

  open() {
    this.menuEl.style.removeProperty("display")
    this.menuEl.removeEventListener('transitionend', this.handleTransitionEnd)
    setTimeout(() => this.menuEl.classList.add('visible'), 0);

    this.menuEl.setAttribute('aria-hidden', 'false');
    this.anchorEl.setAttribute('aria-expanded', 'true');
    this._open = true;

    this.querySelectorAll('a, button').forEach(el => el.setAttribute("tabindex", "0"))

    if (this.isMobile) {
      document.querySelector('.js-overlay')?.classList.add('active')
      setTimeout(() => {
        this.closest('.js-mobile-menu').scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 100)
    }

    this.closeOthers()
  }

  handleTransitionEnd() {
    this.menuEl.style.display = 'none'
  }

  closeOthers() {
    document.querySelectorAll('hh-header-submenu').forEach(el => {
      if (el !== this) {
        el.close()
      }
    })
  }

  close() {
    this.menuEl.classList.remove('visible');
    this.menuEl.addEventListener('transitionend', this.handleTransitionEnd)
    this.menuEl.setAttribute('aria-hidden', 'true');
    this.anchorEl.setAttribute('aria-expanded', 'false');
    this._open = false;

    this.querySelectorAll('a:not(.js-submenu-anchor), button').forEach(el => el.setAttribute("tabindex", "-1"))

    document.querySelector('.js-overlay')?.classList.remove('active')
  }

  mobileSubmenuClose() {
    this.menuEl.classList.remove('visible');
    this.menuEl.addEventListener('transitionend', this.handleTransitionEnd)
    this.menuEl.setAttribute('aria-hidden', 'true');
    this.anchorEl.setAttribute('aria-expanded', 'false');
    this._open = false;

    this.querySelectorAll('a:not(.js-submenu-anchor), button').forEach(el => el.setAttribute("tabindex", "-1"))
  }

  mobileSubmenuCloseAll() {
    this.mobileSubmenuClose()
    this.closest('[data-drawer="mobile-menu"]')?.close()
  }

  handleOutsideEvent(e) {
    if (this._open && (!this.contains(e.target) || e?.code?.toUpperCase() === 'ESCAPE')) {
      this.close()
    }
  }
}

customElements.define('hh-header-submenu', HHHeaderSubmenu);
